/**
 * Permission constants for the new RBAC system.
 * Use these constants directly - never pass entity strings.
 *
 * Usage:
 *   permissionsService.userHasPermission(PERMISSIONS.VIOLATION_OPERATION, integrationId);
 */
export const PERMISSIONS = {
  // Violations
  VIOLATION_VIEWER: 'violation_viewer',
  VIOLATION_ANALYST: 'violation_analyst',
  VIOLATION_OPERATION: 'violation_operation',

  // Inventory
  INVENTORY_VIEWER: 'inventory_viewer',
  INVENTORY_ANALYST: 'inventory_analyst',
  INVENTORY_OPERATION: 'inventory_operation',

  // Agent Steps
  STEP_VIEWER: 'step_viewer',
  STEP_ANALYST: 'step_analyst',
  STEP_OPERATION: 'step_operation',

  // Findings
  FINDING_VIEWER: 'finding_viewer',
  FINDING_ANALYST: 'finding_analyst',
  FINDING_OPERATION: 'finding_operation',

  // Policies
  POLICY_VIEWER: 'policy_viewer',
  POLICY_ANALYST: 'policy_analyst',
  POLICY_OPERATION: 'policy_operation',

  // Playbooks
  PLAYBOOK_VIEWER: 'playbook_viewer',
  PLAYBOOK_ANALYST: 'playbook_analyst',
  PLAYBOOK_OPERATION: 'playbook_operation',

  // Integrations
  INTEGRATION_VIEWER: 'integration_viewer',
  INTEGRATION_OPERATION: 'integration_operation',

  // Issues
  ISSUE_VIEWER: 'issue_viewer',
  ISSUE_OPERATION: 'issue_operation',

  // Zen AI
  ZEN_AI_VIEWER: 'zen_ai_viewer',

  // Global (organization-level)
  GLOBAL_VIEWER: 'global_viewer',
  GLOBAL_OPERATOR: 'global_operator',
  GLOBAL_OPERATION: 'global_operation',
} as const;

/**
 * Type derived from PERMISSIONS const - ensures type safety.
 */
export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
